module.exports = __webpack_public_path__ + "static/img/50.0fa27cc8.png";